import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  jwt: "",
  user: {},
};

const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload.user;
      state.jwt = action.payload.jwt;
    },
    removeUser: (state) => {
      state.user = {};
      state.jwt = "";
    },
    setUserWithoutJWT: (state, action) => {
      state.user = action.payload.user;
    }
  },
});

export const { setUser, removeUser, setUserWithoutJWT } = userSlice.actions;
export default userSlice.reducer;
